import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';

const NavigationTab = () => {
  const [currentTab, setCurrentTab] = useState('요약정보');
  const [isFixed, setIsFixed] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const { type } = useReportContext();
  const [isScroll, setIsScroll] = useState(false);

  const TabButtons = [
    {
      name: '요약정보',
      onclick: () => {
        setCurrentTab('요약정보');
        handleScroll('요약정보');
      },
    },
    {
      name: '물건기본정보',
      onclick: () => {
        setCurrentTab('물건기본정보');
        handleScroll('물건기본정보');
      },
    },
    {
      name: '매각정보',
      onclick: () => {
        setCurrentTab('매각정보');
        handleScroll('매각정보');
      },
    },
    {
      name: '물건현황',
      onclick: () => {
        setCurrentTab('물건현황');
        handleScroll('물건현황');
      },
    },
    {
      name: '감정가',
      onclick: () => {
        setCurrentTab('감정가');
        handleScroll('감정가');
      },
    },
    {
      name: '임차인현황',
      onclick: () => {
        setCurrentTab('임차인현황');
        handleScroll('임차인현황');
      },
    },
    {
      name: '등기부현황',
      onclick: () => {
        setCurrentTab('등기부현황');
        handleScroll('등기부현황');
      },
    },
    {
      name: '권리분석',
      onclick: () => {
        setCurrentTab('권리분석');
        handleScroll('권리분석');
      },
    },
    {
      name: '예상배당표',
      onclick: () => {
        setCurrentTab('예상배당표');
        handleScroll('예상배당표');
      },
    },
    {
      name: '경매집행비용',
      onclick: () => {
        setCurrentTab('경매집행비용');
        handleScroll('경매집행비용');
      },
    },
    {
      name: '가격분석',
      onclick: () => {
        setCurrentTab('가격분석');
        handleScroll('가격분석');
      },
    },
    {
      name: '매각통계',
      onclick: () => {
        setCurrentTab('매각통계');
        handleScroll('매각통계');
      },
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);

    // 💡 처음 마운트될 때 isFull 설정
    setIsFull(window.innerWidth > 900);

    const handleResize = () => setIsFull(window.innerWidth > 900);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const PAuctionTabButtons = [
    {
      name: '요약정보',
      onclick: () => {
        setCurrentTab('요약정보');
        handleScroll('요약정보');
      },
    },
    {
      name: '물건기본정보',
      onclick: () => {
        setCurrentTab('물건기본정보');
        handleScroll('물건기본정보');
      },
    },
     {
      name: '입찰정보',
      onclick: () => {
        setCurrentTab('입찰정보');
        handleScroll('입찰정보');
      },
    },
     {
      name: '입찰이력정보',
      onclick: () => {
        setCurrentTab('입찰이력정보');
        handleScroll('입찰이력정보');
      },
    },
    {
      name: '입찰방법및입찰제한정보',
      onclick: () => {
        setCurrentTab('입찰방법및입찰제한정보');
        handleScroll('입찰방법및입찰제한정보');
      },
    },
    {
      name: '낙찰후인도/인수책임',
      onclick: () => {
        setCurrentTab('낙찰후인도/인수책임');
        handleScroll('낙찰후인도/인수책임');
      },
    },
     {
      name: '감정가',
      onclick: () => {
        setCurrentTab('감정가');
        handleScroll('감정가');
      },
    },
     {
      name: '물건현황',
      onclick: () => {
        setCurrentTab('물건현황');
        handleScroll('물건현황');
      },
    },
     {
      name: '임차인현황',
      onclick: () => {
        setCurrentTab('임차인현황');
        handleScroll('임차인현황');
      },
    },
     {
      name: '등기부현황',
      onclick: () => {
        setCurrentTab('등기부현황');
        handleScroll('등기부현황');
      },
    },
    {
    name: '가격분석',
    onclick: () => {
      setCurrentTab('가격분석');
      handleScroll('가격분석');
    },
    },
  ];

  const navRef = useRef<HTMLDivElement | null>(null);
  const originalTopRef = useRef<number | null>(null); // 원래 위치를 저장

  useEffect(() => {
    const handleScroll = () => {
      if (navRef.current) {
        const scrollY = window.scrollY; // 브라우저 상단으로부터의 스크롤 위치
        const { top } = navRef.current.getBoundingClientRect();
        // 최초 위치 저장 (스크롤 시작 시 한 번만)
        if (originalTopRef.current === null) {
          originalTopRef.current = top;
        }
        if (scrollY > originalTopRef.current!) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }

        let arr = type === 'a' ? TabButtons : PAuctionTabButtons;

        for (let i = 0; i < arr.length; i++) {
          const element = document.getElementById(arr[i].name);
          if (element) {
            if (element.getBoundingClientRect().bottom > +200) {
              const el2 = document.getElementById(arr[i].name + '_nav');
              if (el2) {
                navRef.current.scrollTo({
                  left: el2.offsetLeft - 10,
                  behavior: 'smooth',
                });
              }
              setCurrentTab(arr[i].name);
              break;
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100; // 덜 이동할 픽셀 값
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      // setIsScroll(true);
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      // requestAnimationFrame(() => {
      //   setIsScroll(false);
      // });
    }
  };

  return (
    <Container ref={navRef} isFull={isFull} isFixed={isFixed}>
      <Inner>
        {(type === 'a' ? TabButtons : PAuctionTabButtons).map((tab, idx) => (
          <TabButton
            key={idx}
            onClick={tab.onclick}
            active={currentTab === tab.name}
            id={tab.name + '_nav'}
          >
            {tab.name}
          </TabButton>
        ))}
      </Inner>
    </Container>
  );
};

export default NavigationTab;

interface ContainerProps {
  isFull: boolean;
  isFixed: boolean;
}

const Container = styled.div<ContainerProps>`
  position: ${(props) => (props.isFixed ? 'fixed' : 'relative')};
  top: ${(props) => (props.isFixed ? '54px' : 'auto')};
  width: ${(props) => (props.isFull ? '900px' : '100%')};
  overflow-x: auto;
  background-color: #fff;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
    height: 8px;
  }
  z-index: 100;
`;
const Inner = styled.div`
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: scroll;
`;
const TabButton = styled.span<{ active: boolean }>`
  padding: 10px 2px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;

  color: ${(props) => (props.active ? '#222222' : '#989BA2')};
  cursor: pointer;
  /* background-color: ${(props) =>
    props.active ? '#222222' : 'rgba(112, 115, 124, 0.08)'}; */
  border-radius: 9999px;
`;